import { Link } from "react-router-dom";
import { Brand, SiteFooter } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";

export const PublicLayout = ({ children, overlay = false, headerCta = null, hideFounding = false }) => {
  const { user } = useAuth();
  return (
    <div className="relative min-h-screen flex flex-col">
      <div aria-hidden="true" className="gold-line absolute inset-x-0 top-0 z-40" />
      <header className={`${overlay ? "absolute inset-x-0 top-0 z-30" : "relative z-10"} mx-auto flex w-full max-w-7xl items-center justify-between gap-3 px-5 py-5 sm:px-8 sm:py-6`}>
        <Brand />
        <nav aria-label="Main" className="flex items-center gap-1 sm:gap-2 text-sm">
          <Link to="/tools" data-testid="header-tools-link" className="hidden min-h-[44px] items-center px-3 text-muted-foreground transition-colors hover:text-foreground sm:inline-flex">Free tools</Link>
          <Link to="/blog" data-testid="header-guides-link" className="hidden min-h-[44px] items-center px-3 text-muted-foreground transition-colors hover:text-foreground sm:inline-flex">Guides</Link>
          <Link to="/etsy-tags" data-testid="header-etsy-tags-link" className="hidden min-h-[44px] items-center px-3 text-muted-foreground transition-colors hover:text-foreground sm:inline-flex">Etsy Tags</Link>
          {headerCta}
          {user ? (
            <Link to="/app" data-testid="header-open-app-link" className="btn-aurora inline-flex min-h-[44px] items-center rounded-full px-5">
              Open app
            </Link>
          ) : (
            <Link to="/login" data-testid="header-login-link" className="inline-flex min-h-[44px] items-center rounded-full border border-white/15 bg-white/[0.04] px-4 sm:px-5 backdrop-blur-md hover:bg-white/[0.08] transition-colors">
              Log in
            </Link>
          )}
        </nav>
      </header>
      <main className="relative flex-1">{children}</main>
      <SiteFooter hideFounding={hideFounding} />
    </div>
  );
};
